export default __webpack_public_path__ + "static/media/powerpoint.f6476255.svg";